/** Mutable runtime state read outside React (the fetcher's X-Org-Id, the 402 bridge). */
import type { Problem } from '@oex/contracts';

export const runtime: {
  orgId: string | null;
  openUpsell: ((problem: Problem) => void) | null;
  onUnauthorized: (() => void) | null;
} = { orgId: null, openUpsell: null, onUnauthorized: null };
